import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AnimatedNumber from 'animated-number-react';
import clsx from 'clsx';
import React from 'react';

import { setColor } from '../../utils/colors';

import { useStyles } from './styles';

interface IProps {
  member: any;
  activity: number;
  previousActivity: number;
  channels: number;
  mood: number;
  currentTeam: any;
  mentionActivity: any;
}

const MemberCard: React.FC<IProps> = React.memo(
  ({ member, activity, channels, mood, currentTeam, previousActivity, mentionActivity }) => {
    const classes = useStyles();
    const formatValue = (value: number) => value.toFixed(0);

    return (
      <Grid item xs={12} md={4}>
        <Paper className={clsx(classes.paper)}>
          {member ? (
            <>
              <Grid item xs={6} className={classes.info}>
                <Avatar src={member ? member.profile.image192 : null} className={classes.large} />
                <Avatar src={currentTeam ? currentTeam.avatar : null} className={classes.company} />
                <Typography component="h2" className={classes.username}>
                  {member.profile.displayName.length
                    ? `@${member.profile.displayName}`
                    : `@${member.profile.realName}`}
                </Typography>
                <Typography component="h2" className={classes.name}>
                  {member.profile.realName}
                </Typography>
                <Typography component="h2" className={classes.tz}>
                  {member.tzLabel}
                </Typography>
                <Typography component="h2" className={classes.categories}>
                  Overall Sentiment
                </Typography>
                <Paper
                  className={classes.paperMoodColor}
                  elevation={0}
                  style={{
                    background: `${mood ? setColor(mood) : setColor(100)}`,
                  }}
                ></Paper>
              </Grid>
              <Grid item xs={6} className={classes.metrics}>
                <Typography component="h2" className={classes.categories}>
                  Total Activity
                </Typography>
                <div className={classes.numberBox}>
                  <AnimatedNumber
                    className={classes.metricNumber}
                    value={activity}
                    formatValue={formatValue}
                  />
                  <Typography className={classes.metricChange}>
                    {previousActivity !== 0
                      ? `(${((activity / previousActivity - 1) * 100).toFixed(2)}%)`
                      : activity === 0
                      ? '0%'
                      : '100%'}
                  </Typography>
                </div>
                <Typography component="h2" className={classes.categories}>
                  Active Channels
                </Typography>
                <AnimatedNumber
                  className={classes.metricNumber}
                  value={channels}
                  formatValue={formatValue}
                />
                <Typography component="h2" className={classes.categories}>
                  Total Mentions
                </Typography>
                <AnimatedNumber
                  className={classes.metricNumber}
                  value={mentionActivity.count}
                  formatValue={formatValue}
                />
                <Typography component="h2" className={classes.categories}>
                  Replied Mentions
                </Typography>
                <div className={classes.numberBox}>
                  <AnimatedNumber
                    className={classes.metricNumber}
                    value={mentionActivity.respondedCount}
                    formatValue={formatValue}
                  />
                  <Typography className={classes.metricChange}>
                    {mentionActivity.count !== 0
                      ? `(${(
                          (mentionActivity.respondedCount / mentionActivity.count) *
                          100
                        ).toFixed(2)}%)`
                      : mentionActivity.respondedCount === 0
                      ? '0%'
                      : '100%'}
                  </Typography>
                </div>
                <Typography component="h2" className={classes.categories}>
                  Avg Response Time
                </Typography>
                <div className={classes.numberBox}>
                  <AnimatedNumber
                    className={classes.metricNumber}
                    value={Math.floor(mentionActivity.avgTime / 60000).toFixed(2)}
                    formatValue={formatValue}
                  />
                  <Typography className={classes.metricChange}>minutes</Typography>
                </div>
              </Grid>
            </>
          ) : null}
        </Paper>
      </Grid>
    );
  }
);

MemberCard.displayName = 'MemberCard';

export { MemberCard };
